import React from "react";
import { Link } from "react-router-dom";

const containerStyle: React.CSSProperties = {
  height: "100vh",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  background: "#f9f9f9",
  color: "#333",
  textAlign: "center",
};

const titleStyle: React.CSSProperties = {
  fontSize: "8rem",
  margin: 0,
};

const messageStyle: React.CSSProperties = {
  fontSize: "1.5rem",
  margin: "1rem 0",
};

const linkStyle: React.CSSProperties = {
  display: "inline-block",
  marginTop: "1rem",
  padding: "0.75rem 1.5rem",
  background: "#007bff",
  color: "#fff",
  textDecoration: "none",
  borderRadius: "4px",
};

const NotFoundPage = () => (
  <div style={containerStyle}>
    <h1 style={titleStyle}>404</h1>
    <p style={messageStyle}>
      Oops! The page you're looking for can't be found.
    </p>
    <Link to="/" style={linkStyle}>
      Return Home
    </Link>
  </div>
);

export default NotFoundPage;
